import { FormEvent, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ArrowRight, LockKeyhole, ShieldCheck } from 'lucide-react';
import { api, jsonBody } from '../api';

export function LoginPage() {
  const queryClient = useQueryClient();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const login = useMutation({
    mutationFn: () => api('/api/auth/login', {
      method: 'POST',
      ...jsonBody({ username, password })
    }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['session'] })
  });

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (username && password) login.mutate();
  };

  return (
    <main className="login-page">
      <section className="login-atmosphere" aria-hidden="true">
        <div className="signal-orbit orbit-one" /><div className="signal-orbit orbit-two" />
        <div className="strategy-stamp"><span>STRATEGY / 01</span><strong>EMA 120</strong><i>ATR 60</i></div>
        <blockquote>“稳定运行，清楚决策，<br />让每一次执行都可以被解释。”</blockquote>
        <div className="login-facts"><span>4H SIGNAL</span><span>MULTI ACCOUNT</span><span>AUDIT READY</span></div>
      </section>
      <section className="login-panel">
        <div className="login-card">
          <div className="login-mark"><img src="/icons/app-icon-192.png" alt="" /><span>EMA · ATR</span></div>
          <div className="login-heading"><h1>登录交易控制台</h1><p>会话有效期 7 天</p></div>
          <form onSubmit={submit}>
            <label><span>管理员账号</span><input autoFocus autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} /></label>
            <label><span>密码</span><input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} /></label>
            {login.error ? <div className="form-error">{login.error.message}</div> : null}
            <button className="primary-button login-button" disabled={login.isPending || !username || !password}>
              {login.isPending ? '正在验证' : '进入控制台'}<ArrowRight size={18} />
            </button>
          </form>
          <div className="security-note"><ShieldCheck size={16} /><span>登录凭据由服务器环境提供，浏览器不会保存密码。</span></div>
          <div className="session-note"><LockKeyhole size={14} />安全 Cookie · SameSite Strict</div>
        </div>
      </section>
    </main>
  );
}
